import { ROUTES } from "@nf/constants";
import { type GetServerSideProps } from "next";

import { buildSortField } from "helpers";

import GenresScreen from "screens/GenresScreen";

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const setCacheHeader = await import("helpers/cacheHeaderHelper").then(
    (mod) => mod.setCacheHeader
  );
  setCacheHeader(ctx.res);
  const { getCommonServerSideProps } = await import(
    "helpers/getCommonServerSideProps"
  );
  const { commonProps, DataProvider } = await getCommonServerSideProps(ctx);
  const mediaListId = `${ctx?.query?.id}`;
  const queryParams = ctx.query || undefined;
  const sortParam = Array.isArray(queryParams?.sort)
    ? queryParams.sort[0]
    : queryParams.sort;

  let mediaList = {};

  try {
    mediaList = await DataProvider.getMediaList({
      MediaListId: mediaListId,
      QueryParams: {
        ...queryParams,
        sort: buildSortField(sortParam, commonProps.lang),
        category: mediaListId,
      },
      MediaMapperOptions: {
        IsList: true,
        ExcludeYear: true,
        ExcludeLongDescription: true,
        ExcludeContentAdvisory: true,
        FirstCategoryOnly: true,
        ExcludeImagesFromCategories: true,
        ExcludeSeasons: true,
        ExcludeSubtitles: true,
        ExcludeImageType: [
          "HERO_FRONTPAGE",
          "HERO_ASSET_DETAILS",
          //"BANNER",
          //"THUMBNAIL",
          //"HOVER_ASSET",
        ],
      },
    });
  } catch (e) {
    return {
      redirect: {
        destination: `/${commonProps.country}/${commonProps.lang}${ROUTES.PAGE_NOT_FOUND}?&id=${mediaListId}`,
      },
      props: {
        error: e,
        ...commonProps,
      },
    };
  }

  const categories = await DataProvider.getMediaCategories(true);

  const category = categories?.Entities?.find(
    ({ CategoryId }) => CategoryId.toString() === mediaListId.toString()
  );

  return {
    props: {
      categories,
      category,
      mediaList,
      ...commonProps,
    },
  };
};

export default GenresScreen;
